








































import LoginForm from './login-form.component.vue';

export default {
  name: 'login',
  components: {
    LoginForm: LoginForm
  },
  computed: {
    activeEvent: function () {
      return this.scheduledEvents.find((event: any) => ((event.startDate <= new Date()) && (event.endDate > new Date())));
    }
  },
  props: {
    resetPasswordUrl: String,
    scheduledEvents: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onLogin: function (success: boolean) {
      this.$emit('login', success);
    }
  }
};

